import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addManager } from "../../api/admin";
import { auth, projectStorage } from "../../firebase";

const AddManagerForm = ({ loadManagers }) => {
  const initialVals = {
    fname: "",
    lname: "",
    phone: "",
    email: "",
    profile: "",
    address: {
      first_line: "",
      second_line: "",
      city: "",
    },
  };
  const { user } = useSelector((state) => ({ ...state }));
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState(initialVals);
  const [image, setImage] = useState([]);

  const handleChange = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleAddressChange = (e) => {
    let { address } = values;
    setValues({
      ...values,
      address: { ...address, [e.target.name]: e.target.value },
    });
  };

  // const handleCityChange = (city) => {
  //   let { address } = values;
  //   address.city = city;
  //   setValues({ ...values, address });
  // };

  // const handleCountryChange = (country) => {
  //   let { address } = values;
  //   address.country = country;
  //   setValues({ ...values, address });
  // };

  // const handleCountrySelect = async (e) => {
  //   setLoadingCities(true);
  //   if (e.target.value !== "Please select the country") {
  //     try {
  //       const country = countries.filter(
  //         (each) => each.country === e.target.value
  //       );
  //       setCities(country[0].cities);
  //       handleCountryChange(e.target.value);
  //       handleCityChange("");
  //       setLoadingCities(false);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     handleCountryChange("");
  //     setCities([]);
  //     handleCityChange("");
  //   }
  // };

  // const handleCitySelect = async (e) => {
  //   if (e.target.value !== "Please select the city") {
  //     try {
  //       handleCityChange(e.target.value);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     handleCityChange("");
  //   }
  // };

  const handleImageSelect = async (e) => {
    if (e.target.files) {
      setImage(e.target.files);
    } else {
      setImage("");
      toast.error("Please select valid doc");
    }
  };

  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      try {
        let storageRef = projectStorage.ref(
          "/Gym/" + user._id + "/Manager/Profile" + image.name
        );
        storageRef.put(image).on(
          "state_changed",
          null,
          (err) => console.log(err),
          async () => {
            resolve(await storageRef.getDownloadURL());
          }
        );
      } catch (error) {
        reject(error);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (image) values.profile = await uploadImage();
      values.email = values.email.toLocaleLowerCase();
      const res = await addManager(user.token, values);
      setValues(initialVals);
      loadManagers();
      toast.success("Manager Added");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response
          ? error.response.data
          : "Some error occured please try later"
      );
      console.log(error);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6">
            <label htmlFor="fname" className="form-label">
              First Name
            </label>
            <input
              type="text"
              name="fname"
              value={values.fname}
              placeholder="Vikram"
              className="form-control mb-3"
              id="fname"
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="lname" className="form-label">
              Last Name
            </label>
            <input
              type="text"
              name="lname"
              value={values.lname}
              placeholder="Singh"
              className="form-control mb-3"
              id="lname"
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <label htmlFor="phone" className="form-label">
              Phone
            </label>
            <input
              type="number"
              name="phone"
              placeholder="99999993467"
              value={values.phone}
              className="form-control mb-3"
              id="phone"
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="email" className="form-label">
              Email address
            </label>
            <input
              type="email"
              name="email"
              value={values.email}
              className="form-control mb-3"
              placeholder="info@gmail.com"
              id="email"
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6 text-center">
            <label htmlFor="profile" className="form-label">
              Upload Profile Image
            </label>
            <input
              type="file"
              accept="image/*"
              id="profile"
              onChange={handleImageSelect}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <label htmlFor="first_line" className="form-label">
              Address
            </label>
            <input
              type="text"
              value={values.address.first_line}
              name="first_line"
              placeholder="House No. 4, Block No. 4"
              className="form-control mb-3"
              id="first_line"
              onChange={handleAddressChange}
              required
            />
          </div>
          <div className="col-md-12">
            <input
              type="text"
              value={values.address.second_line}
              name="second_line"
              placeholder="Indraprastha Colony"
              className="form-control mb-3"
              id="second_line"
              onChange={handleAddressChange}
            />
          </div>
        </div>
        <div className="row">
          {/* <div className="col-md-12"> */}
          <label htmlFor="city" className="form-label">
            City
          </label>
          <input
            type="text"
            value={values.address.city}
            name="city"
            placeholder="Bangalore,Delhi"
            className="form-control mb-3"
            id="city"
            onChange={handleAddressChange}
            required
          />
          {/* </div> */}
        </div>
        <button type="submit" className="btn btn-primary btn-block w-100">
          Submit
        </button>
      </form>
    </>
  );
};

export default AddManagerForm;
